import React from 'react';
import { CssBaseline } from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './contexts/AuthContext';
import { CustomThemeProvider } from './contexts/ThemeContext';
import SimpleApp from './components/SimpleApp';

function App() {
  return (
    <CustomThemeProvider>
      <CssBaseline />
      <AuthProvider>
        <SimpleApp />
      </AuthProvider>
    </CustomThemeProvider>
  );
}

export default App;